module.exports = __webpack_public_path__ + "static/img/tsid1.f72d61a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tsid1.png
// module id = +x8b
// module chunks = 1